import styled from '@emotion/styled'

type ExcelDownLoadProps = {
	onDownload: () => void
}
const ExcelDownLoad = ({ onDownload }: ExcelDownLoadProps) => {
	return (
		<Block>
			<DownLoadBtn onClick={onDownload}>엑셀 다운로드</DownLoadBtn>
		</Block>
	)
}

const Block = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 1.4rem;
	padding-bottom: 1.4rem;
	padding-right: 2.8rem;
	background-color: #e1e3ea;
`

const DownLoadBtn = styled.button`
	border: none;
	padding: 0.8rem;
	background-color: #fff;
	border-radius: 0.7rem;
	font-size: 1.4rem;
	font-weight: 500;
	line-height: 1.9rem;
`

export default ExcelDownLoad
